module.exports = __webpack_public_path__ + "static/media/2.11a6a084.jpg";